import { Navigate, createBrowserRouter } from 'react-router';

// Layouts
import AdminLayout from '@/layouts/admin-layout';
import AppLayout from '@/layouts/app-layout';
import AuthLayout from '@/layouts/auth-layout';

// Admin pages
import AdminDashboardPage from '@/pages/admin/dashboard';
import AdminInterestsPage from '@/pages/admin/interests';
import AdminLettersPage from '@/pages/admin/letters';
import AdminReportDetailPage from '@/pages/admin/reports/detail';
import AdminReportsPage from '@/pages/admin/reports/index';
import AdminSessionsPage from '@/pages/admin/sessions';
import AdminUserDetailPage from '@/pages/admin/users/detail';
import AdminUsersPage from '@/pages/admin/users/index';

import ComposePage from '@/pages/compose';
import DiscoverPage from '@/pages/discover';
import DraftsPage from '@/pages/drafts';
import ForgotPasswordPage from '@/pages/forgot-password';
import InTransitPage from '@/pages/in-transit';
// Pages
import InboxPage from '@/pages/inbox';
import LetterViewPage from '@/pages/letter-view';
import LoginPage from '@/pages/login';
import ProfilePage from '@/pages/profile';
import RegisterPage from '@/pages/register';
import ResetPasswordPage from '@/pages/reset-password';
import SentPage from '@/pages/sent';
import UserProfilePage from '@/pages/user-profile';
import VerifyEmailPage from '@/pages/verify-email';

export const router = createBrowserRouter([
  // Root redirect
  {
    path: '/',
    element: <Navigate to="/inbox" replace />
  },
  // App routes (protected)
  {
    element: <AppLayout />,
    children: [
      { path: '/inbox', element: <InboxPage /> },
      { path: '/sent', element: <SentPage /> },
      { path: '/drafts', element: <DraftsPage /> },
      { path: '/in-transit', element: <InTransitPage /> },
      { path: '/compose', element: <ComposePage /> },
      { path: '/discover', element: <DiscoverPage /> },
      { path: '/profile', element: <ProfilePage /> },
      { path: '/letter/:id', element: <LetterViewPage /> },
      { path: '/user/:username', element: <UserProfilePage /> }
    ]
  },
  // Admin routes (protected, admin only)
  {
    element: <AdminLayout />,
    children: [
      { path: '/admin', element: <AdminDashboardPage /> },
      { path: '/admin/users', element: <AdminUsersPage /> },
      { path: '/admin/users/:id', element: <AdminUserDetailPage /> },
      { path: '/admin/reports', element: <AdminReportsPage /> },
      { path: '/admin/reports/:id', element: <AdminReportDetailPage /> },
      { path: '/admin/letters', element: <AdminLettersPage /> },
      { path: '/admin/interests', element: <AdminInterestsPage /> },
      { path: '/admin/sessions', element: <AdminSessionsPage /> }
    ]
  },
  // Auth routes (public)
  {
    element: <AuthLayout />,
    children: [
      { path: '/login', element: <LoginPage /> },
      { path: '/register', element: <RegisterPage /> },
      { path: '/verify-email', element: <VerifyEmailPage /> },
      { path: '/forgot-password', element: <ForgotPasswordPage /> },
      { path: '/reset-password', element: <ResetPasswordPage /> }
    ]
  }
]);
